var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-nav'),_c('h1',{staticClass:"text-white mt-5"},[_vm._v("Sorry, page not found.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }